const COPY_BUTTON_SELECTOR = '[data-coupon-code]';

if (!window.nativeCouponCopyReady) {
  window.nativeCouponCopyReady = true;

  document.addEventListener('click', async (event) => {
    const button = event.target.closest(COPY_BUTTON_SELECTOR);
    if (!(button instanceof HTMLButtonElement)) return;

    const code = button.dataset.couponCode;
    const label = button.querySelector('[data-copy-label]');
    if (!code || !label) return;

    try {
      await navigator.clipboard.writeText(code);
      label.textContent = 'Copied!';
      window.setTimeout(() => {
        label.textContent = 'Copy Code';
      }, 3000);
    } catch (error) {
      console.error('Unable to copy coupon code', error);
    }
  });
}
